import { render, staticRenderFns } from "./long-text.vue?vue&type=template&id=3330183e&scoped=true&"
import script from "./long-text.vue?vue&type=script&lang=js&"
export * from "./long-text.vue?vue&type=script&lang=js&"
import style0 from "./long-text.vue?vue&type=style&index=0&id=3330183e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3330183e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VImg,VSheet})
